(function () {
	'use strict';
	$(document).ready(function () {

		$('.search-trigger').on('click', function() {
			$('.search-panel').fadeToggle();
		});

	});
}(jQuery));
